export default __webpack_public_path__ + "static/media/search.865a147a.svg";